import axios from 'axios'

export const AdminUserService = {
  /**
   * Login to ICC Code Adoption admin with user provided credentials
   * @param data | user form data
   */
  fetchUserList () {
    return axios.get(`/api/v1/userlist`)
  },
  addAdminUser (data) {
    return axios.post(`/api/v1/adduser`, JSON.stringify({
      username: data.username,
      firstName: data.firstName,
      lastName: data.lastName,
      userId: data.userId,
      company: data.company,
      password: data.password,
      confirmPassword: data.confirmPassword,
      status: data.status,
      role: data.role
    }))
  },
  editAdminUser (data) {
    return axios.post(`/api/v1/edituser`, JSON.stringify({
      username: data.username,
      firstName: data.firstName,
      lastName: data.lastName,
      userId: data.userId,
      company: data.company,
      status: data.status,
      role: data.role,
      id: data.id
    }))
  },
  validateAdminUser (data) {
    return axios.delete(`/api/v1/deleteuser`, { data: data })
  },
  deleteAdminUser (data) {
    return axios.delete(`/api/v1/deleteuser`, { data: data })
  }
}
